import React from 'react';

const Services = () => {
    return (
        <div className='mt-16'>
            <h2 className='text-3xl font-bold text-center text-primary'>WHY CHOOSE US</h2>
            <h3 className='text-3xl text-center'>We are provide excellent service to the customers.</h3>

            <div className=' mx-6'>

                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4 my-6 mx-4'>
                    <div className=' rounded drop-shadow-xl bg-slate-300 p-3'>
                        <img src="https://thumbs.dreamstime.com/b/woman-book-store-selling-books-woman-book-store-selling-books-vector-illustration-135559633.jpg" alt="" />
                        <h2 className='text-1xl font-bold'>Best Selling service </h2>
                    </div>
                    <div className=' rounded drop-shadow-xl bg-slate-300 p-3'>
                        <img src="https://images.squarespace-cdn.com/content/v1/5cb1f6beaadd34703fcc968c/1569595288601-J3HQ0R66LMQ2BL709K3B/GBA-Book+Chain+Graphic_Distribution+Management.png?format=1000w" alt="" />
                        <h2 className='text-1xl font-bold'>On time Delivery </h2>
                    </div>
                    <div className=' rounded drop-shadow-xl bg-slate-300 p-3'>
                        <img src="https://www.workncdental.com/images/icons/hexagon/darkblue/MI_DARK_BLUE_ICON_SUPPORT.png" alt="" />
                        <h2 className='text-1xl font-bold'>12/7 Support </h2>
                    </div>
                    <div className=' rounded drop-shadow-xl bg-slate-300 p-3'>
                        <img src="https://media.istockphoto.com/id/1170514222/vector/businessman-in-bookstore-flat-vector-illustration.jpg?s=612x612&w=0&k=20&c=9xgyZ_elFJhm8oxLA_79utCmiWVEY6_7WfEHj3qNwgw=" alt="" />
                        <h2 className='text-1xl font-bold'>Best Buyer service </h2>
                    </div>
                    <div className=' rounded drop-shadow-xl bg-slate-300 p-3'>
                        <img src="https://www.kindpng.com/picc/m/464-4641896_royalty-free-book-clip-art-reading-book-clipart.png" alt="" />
                        <h2 className='text-1xl font-bold'>User Friendly </h2>
                    </div>
                    <div className=' rounded drop-shadow-xl bg-slate-300 p-3'>
                        <img src="https://creazilla-store.fra1.digitaloceanspaces.com/cliparts/3229460/easy-payment-clipart-xl.png" alt="" />
                        <h2 className='text-1xl font-bold'>Easy payment </h2>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services;